var render, staticRenderFns
import script from "./checkAndPOP.vue?vue&type=script&lang=js&"
export * from "./checkAndPOP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5435f0fc",
  null
  
)

export default component.exports